var _defs, _path, _ellipse, _path2;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgBarsAndNightlife(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "32px",
    height: "44px",
    id: "Layer_1",
    "data-name": "Layer 1",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 44",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".cls-1{fill:#f9218e;}.cls-2{fill:#fff;}"))), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "bars_and_nightlife") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M16,0A16,16,0,0,0,0,15.92C0,26.83,14.3,42.85,14.9,43.55a1.45,1.45,0,0,0,2.1,0c.7-.7,15-16.72,15-27.63A16,16,0,0,0,16,0Zm0,24a8,8,0,1,1,8.1-8A8.12,8.12,0,0,1,16,24Z"
  })), _ellipse || (_ellipse = /*#__PURE__*/React.createElement("ellipse", {
    className: "cls-2",
    cx: 16,
    cy: 15.82,
    rx: 12,
    ry: 12.01
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M22.8,10.61c.2-.1.2-.4.2-.6a.66.66,0,0,0-.5-.4H20.2a2,2,0,0,0-.5-1.7l.1-.3a.6.6,0,0,0-1.1-.5l-.1.3h0a2.22,2.22,0,0,0-1.9,1.5,6.37,6.37,0,0,0-.2.7h-7A.51.51,0,0,0,9,10a.56.56,0,0,0,.1.6l6.3,6.31v4.5l-2.3,2.31a.47.47,0,0,0-.1.6.66.66,0,0,0,.5.4h5a.51.51,0,0,0,.5-.4.61.61,0,0,0-.1-.6l-2.3-2.31v-4.5Zm-4.7,1.2a2.2,2.2,0,0,0,1.6-.9H21l-1.7,1.7H17.8Zm-1.5.7H12.7L11,10.81h5.7a2.19,2.19,0,0,0,.3.5Z"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgBarsAndNightlife);
export default __webpack_public_path__ + "static/media/bars_and_nightlife.382fd13b11b670e6fde0c08d5c80fa88.svg";
export { ForwardRef as ReactComponent };